import { render, staticRenderFns } from "./UserGoalNotesDialog.vue?vue&type=template&id=1d2a4b81"
import script from "./UserGoalNotesDialog.ts?vue&type=script&lang=ts&external"
export * from "./UserGoalNotesDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./UserGoalNotesDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports